import ymap from '../load-ymap';
import throttle from 'lodash-es/debounce';

export default () => {
  const $root = $('.map');
  let map = null;
  let objects = $root.find('#object').data('object');

  const enabledTypes = [];
  const zoom = $(window).outerWidth() <= 991 ? 16 : 14;

  if(objects !== undefined){
    function mapLoad() {
      ymap.load().then(()=> {
        ymaps.ready(() => {
          map = new ymaps.Map('map', {
              center: objects[0].coordinates.split(","),
              zoom: zoom,
              controls: []
            },
            {
              searchControlProvider: 'yandex#search',
            });

          const ZoomLayout = ymaps.templateLayoutFactory.createClass("<div class='map-zoom'>" +
            "<div class='map-wrap'>"+
            "<div id='zoom-in' class='map-btn map-btn--plus'>+</div>" +
            "<div id='zoom-out' class='map-btn'>-</div>" +
            "</div>" +
            "<div id='geo-lock' class='map-icon-lock'></div>" +
            "</div>", {

            build: function () {
              ZoomLayout.superclass.build.call(this);
              this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
              this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);
              this.geoLockCallback = ymaps.util.bind(this.geoLock, this);

              $('#zoom-in').bind('click', this.zoomInCallback);
              $('#zoom-out').bind('click', this.zoomOutCallback);
              $('#geo-lock').bind('click', this.geoLockCallback);
            },

            clear: function () {
              $('#zoom-in').unbind('click', this.zoomInCallback);
              $('#zoom-out').unbind('click', this.zoomOutCallback);
              $('#geo-lock').bind('click', this.geoLockCallback);

              ZoomLayout.superclass.clear.call(this);
            },

            zoomIn: function () {
              const map = this.getData().control.getMap();
              map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
            },

            zoomOut: function () {
              var map = this.getData().control.getMap();
              map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
            },
            geoLock: () => {
              ymaps.geolocation.get({provider: "yandex"})
                .then(function (res) {
                  map.setCenter(res.geoObjects.position);
                  res.geoObjects.options.set('preset', 'islands#redCircleIcon');
                  res.geoObjects.get(0).properties.set({
                    balloonContentBody: 'Вы здесь'
                  });
                  map.geoObjects.add(res.geoObjects);
                })
                .catch(function (err) {
                  console.log('Не удалось установить местоположение', err);
                });
            }
          });

          const zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});
          map.controls.add(zoomControl);

          runFilter();
          resizeZoom();
        });

        const collectObject = new ymaps.GeoObjectCollection();

        function runFilter() {
          collectObject.removeAll();
          objects.forEach((item,index) => {
            const coords = objects[index].coordinates.split(",");
            if(enabledTypes.length == 0 || enabledTypes.indexOf(item.type) !== -1){
              const placemark = new ymaps.Placemark(coords,{},
                {
                  iconLayout: 'default#image',
                  iconImageHref: `${window.location.origin}${item.href}`,
                  // iconImageSize: [40, 60],
                });
              collectObject.add(placemark);
              map.geoObjects.add(collectObject);
            }
          });
        }

        function resizeZoom() {
          $(window).on('resize', throttle(() => {
            if($(window).outerWidth() <= 991){
              map.setZoom(16)
            } else {
              map.setZoom(14)
            }
          },100));
        }

        $root.find('.map__filter-link').on('click', (e) => {
          e.preventDefault();
          const $target = $(e.currentTarget);
          const type = $target.data('type');
          const ind = enabledTypes.indexOf(type);
          if(ind == -1){
            enabledTypes.push(type);
            $target.addClass('map__filter-link--active');
          } else {
            $target.removeClass('map__filter-link--active');
            enabledTypes.splice(ind, 1)
          }
          runFilter();
        })
      });
    }
    mapLoad();

    $root.find('.map__filter-cover').on('scroll', (e) => {
      const $target = $(e.target);
      const $wrap = $root.find('.map__filter-container');
      if($target.scrollTop() > 14) {
        $wrap.addClass('map__filter--scroll');
      } else {
        $wrap.removeClass('map__filter--scroll');
      }
    });

    const $btn = $root.find('.map__filter-show');

    $btn.on('click', (e) => {
      e.preventDefault();
      const $list = $root.find('.map__filter-container');
      $list.toggleClass('map__filter-container--show');
      if($list.hasClass('map__filter-container--show')) {
        $btn.find('span').html('Скрыть');
      } else {
        $btn.find('span').html('Показать все');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/map/index.js